import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--left",
  "use": "icon-slider--left-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 42 42\" id=\"icon-slider--left\"><rect x=\"-.5\" y=\".5\" width=\"41\" height=\"41\" rx=\"20.5\" transform=\"matrix(-1 0 0 1 41 0)\" fill=\"#fff\" stroke=\"#61759E\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m18.828 20.707 5.293-5.293L22.707 14 16 20.707l6.707 6.707L24.121 26l-5.293-5.293Z\" fill=\"#61759E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol